/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { CLIENT_ID, RoutePath } from '@routes/constants/routesConstants';

import { ITableLinkProps } from './types';

export const useTableReportNameCell = (id: number, value: string): ITableLinkProps => {
    return {
        isExternalUrl: false,
        url: RoutePath.autoReportId.replace(CLIENT_ID, String(id)),
        children: value ?? null,
        noValue: !id || !value,
    };
};
